import React from "react";
import { Helmet } from "react-helmet";
import { shallowEqual, useSelector, useDispatch } from "react-redux";

import { setRequestStatus } from "../../application/actions/miscActions";
import {
  searchMerchant,
  setTypeState,
  setIsLoadMore,
  clearFilterNearMeCategoryState,
} from "../../application/actions/merchantActions";

import { useCategory, useDidMount } from "../../application/hooks";

import {
  HomePageTopNav,
  BottomNav,
  BottomSpace,
  MerchantSearch,
  LanguageChooser,
} from "../components/common";

import {
  CategoryListContainer,
  MerchantList,
  MerchantItem,
  SearchMerchantItem,
  FilterNearestMerchantItem,
  FilterDistrictMerchantItem,
} from "../";

import "../../App.css";
import "./style.css";

import Banner from "../Promo/PromoDashboard/Banner";
import { getPromoMerchants } from "../../application/actions/promoActions";
import MerchantLoadList from "../Merchant/MerchantsLoadList";
import { t } from "../../miscellaneous/language";

const HomeContainer = () => {
  const dispatch = useDispatch();
  const didMount = useDidMount(true);

  const store = useSelector(
    (state) => ({
      merchants: state.merchants,
      requestStatus: state.app.requestStatus,
      keyword: state.merchants.keyword,
      isLoading: state.app.loading,
      auth: state.auth,
      promo: state.promo,
      next: state.merchants.next,
    }),
    shallowEqual
  );

  const { auth, keyword, merchants, promo, isLoading } = store;
  const userData = auth.userData || {};
  const promoMerchants = promo.merchants?.data || [];
  const hasCompletedPromoRequest = promo.merchants?.requestComplete;
 
  const { categories } = useCategory(
    userData.userID,
    
    userData.lat,
    userData.lon,
    userData.city,
    userData.host,
    userData.name,
    userData.addressName
  );

  const [filterState, setFilterState] = React.useState({
    nearMe: true,
    district: false,
  });
  const [languageModal, setLanguageModal] = React.useState(false);

  React.useEffect(() => {
    if (promoMerchants.length === 0 && !hasCompletedPromoRequest) {
      dispatch(getPromoMerchants());
    }
  }, [dispatch, hasCompletedPromoRequest, promoMerchants.length]);

  React.useEffect(() => {
    if (didMount && keyword) {
      setFilterState({ nearMe: false });
      dispatch(searchMerchant(keyword));
      return;
    }

    if (filterState?.nearMe || (keyword === "" && !filterState?.district)) {
      setFilterState({ nearMe: true });
      dispatch(setIsLoadMore(false));
      dispatch(setTypeState("FILTER_NEAR_ME"));
    }
  }, [
    didMount,
    keyword,
    filterState?.nearMe,
    filterState?.district,
    dispatch,
  ]);

  React.useEffect(
    () => () => {
      dispatch(setRequestStatus(""));
      dispatch(clearFilterNearMeCategoryState());
    },
    [dispatch]
  );

  const merchantItems = React.useMemo(() => {
    const renderMerchants = (type) => {
      switch (type) {
        case "SEARCH":
          return (
            <SearchMerchantItem merchants={merchants?.searchedItems?.items} />
          );
        case "DEFAULT":
          return <MerchantItem merchants={merchants} />;
        case "FILTER_DISTRICT":
          return (
            <FilterDistrictMerchantItem
              merchants={merchants?.filterDistrict?.items}
            />
          );
        default:
          return (
            <FilterNearestMerchantItem
              merchants={merchants?.filterNearMe?.items}
            />
          );
      }
    };

    return renderMerchants(merchants.type);
  }, [merchants]);

  const listBottomSpace = isLoading ? (
    <MerchantLoadList />
  ) : (
    <div className="home-list-bottom-space" />
  );

  return (
    <>
      <Helmet>
        <title>{t.helmet.title.Home}</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content={t.helmet.desc.Home} />
      </Helmet>

      <HomePageTopNav
        setLanguageModal={setLanguageModal}
        addressName={userData?.addressName}
      />

      <main className="home-page">
        <section className="home-discovery">
          <MerchantSearch />
          <CategoryListContainer items={categories?.result} />
        </section>

        {promoMerchants?.length > 0 && (
          <section className="home-promo">
            <Banner merchants={promoMerchants} />
          </section>
        )}

        <MerchantList {...store}>
          {merchantItems}
          {listBottomSpace}
        </MerchantList>
      </main>

      <BottomNav />
      <BottomSpace />
      <LanguageChooser
        LanguageModal={languageModal}
        setLanguageModal={setLanguageModal}
      />
    </>
  );
};

export default HomeContainer;
